/* Coria · „Completeaza manichiura” in cos (drawer + /cart). HTML-ul se construieste o data si se scrie dintr-o bucata (fara layout fortat). */
(function () {
  if (window.__cfBoost) return; window.__cfBoost = 1;
  var COLOR = /^(gel color|oja semipermanenta|oja stampila|cat eye|gel polish)$/i;
  var BASE = /^rubber base$/i, TOP = /^top coat$/i;
  var pool = null, cache = {};
  function money(c) { return (c / 100).toFixed(2) + ' Lei'; }
  function getJSON(u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function prod(h) { if (!h) return Promise.resolve(null); if (!cache[h]) cache[h] = getJSON('/products/' + h + '.js'); return cache[h]; }
  var pairs = null;
  function loadPairs(u) { if (!u) return Promise.resolve({}); if (!pairs) pairs = getJSON(u).then(function (d) { return d || {}; }); return pairs; }
  function loadPool(h) { if (!pool) pool = getJSON('/collections/' + h + '/products.json?limit=60&sort_by=best-selling').then(function (d) { return (d && d.products) || []; }); return pool; }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function cents(v) { return typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price; }
  function wasCents(v) { var c = v.compare_at_price; if (c == null || c === '') return 0; return typeof c === 'string' ? Math.round(parseFloat(c) * 100) : +c; }
  function priceHtml(v) { var now = cents(v), was = wasCents(v); return money(now) + (was > now ? ' <s>' + money(was) + '</s>' : ''); }
  function imgOf(p) {
    var i = p.featured_image || (p.images && p.images[0]) || '';
    if (i && typeof i === 'object') i = i.src;
    return i ? String(i).split('?')[0] + '?width=160' : '';
  }
  function card(p, v, why) {
    return '<div class="cf-boost__item"><img src="' + esc(imgOf(p)) + '" alt="' + esc(p.title) + '" width="56" height="56" loading="lazy">' +
      '<div class="cf-boost__txt"><small>' + esc(why) + '</small><b>' + esc(p.title) + '</b><span>' + priceHtml(v) + '</span></div>' +
      '<button type="button" class="cf-boost__add" data-cf-boost-add="' + v.id + '" aria-label="Adauga ' + esc(p.title) + '">+</button></div>';
  }
  /* 20.10.2026 CLS: semnatura cosului (ca data-sig din Liquid) -> HTML-ul construit se pastreaza in sessionStorage */
  function sigOf(cart) { return cart.total_price + cart.items.map(function (i) { return '|' + i.key + ':' + i.quantity; }).join(''); }
  function unwait(box) { box.classList.remove('cf-boost--wait'); box.style.minHeight = ''; }
  function remember(box, cart) {
    try {
      sessionStorage.setItem('cfb:' + sigOf(cart), box.innerHTML);
      var w = innerWidth < 768 ? 'm' : 'd', where = box.closest('cart-drawer') ? 'dr' : 'pg';
      if (box.offsetHeight > 0) localStorage.setItem('cfb-h:' + where + ':' + w, String(box.offsetHeight)); /* sertarul inchis are 0 */
    } catch (e) {}
  }
  function render(box) {
    (window.coriaCartJsShared ? window.coriaCartJsShared().catch(function () { return null; }) : getJSON('/cart.js')).then(function (cart) {
      if (!cart || !cart.item_count) { unwait(box); box.hidden = true; return; }
      var inCart = {}, hasColor = false, hasBase = false, hasTop = false;
      cart.items.forEach(function (i) {
        inCart[i.handle] = 1;
        var t = (i.product_type || '').trim();
        if (COLOR.test(t)) hasColor = true; if (BASE.test(t)) hasBase = true; if (TOP.test(t)) hasTop = true;
      });
      var need = [];
      if (hasColor && !hasBase && !inCart[box.dataset.base]) need.push([box.dataset.base, 'Baza pentru rezistenta']);
      if (hasColor && !hasTop && !inCart[box.dataset.top]) need.push([box.dataset.top, 'Top coat pentru luciu']);
      var free = (cart.total_weight > 5000) ? 0 : (+box.dataset.free || 0), left = free ? free - cart.total_price : 0;
      /* 19.10.2026: sub comanda minima (100 lei) completam intai pana la minim, nu pana la transport gratuit
         (ex. Blooming Gel 42 lei din reclame: 10 cosuri, 0 comenzi in 14 zile) */
      var minC = +box.dataset.min || 0, minLeft = minC ? minC - cart.total_price : 0, forMin = minLeft > 0;
      if (forMin) left = minLeft;
      loadPairs(box.dataset.pairs).then(function (P) {
      var sc = {};
      cart.items.forEach(function (i) { (P[i.handle] || []).forEach(function (r) { if (!inCart[r[0]] && (!sc[r[0]] || sc[r[0]] < r[1])) sc[r[0]] = r[1]; }); });
      var together = Object.keys(sc).sort(function (a, b) { return sc[b] - sc[a]; }).slice(0, 4);
      Promise.all(together.map(prod)).then(function (tp) {
      Promise.all([
        Promise.all(need.map(function (n) { return prod(n[0]); })),
        left > 0 && (forMin || left <= (+box.dataset.near || 12000)) ? loadPool(box.dataset.pool) : Promise.resolve([])
      ]).then(function (res) {
        var html = '', fill = '', tog = '', shown = {}, nTog = 0;
        tp.forEach(function (p) {
          if (!p || nTog >= 3) return; var v = p.variants.filter(function (x) { return x.available; })[0]; if (!v) return;
          shown[p.handle] = 1; nTog++; tog += card(p, v, 'Cumparat des impreuna');
        });
        need = need.filter(function (n) { return !shown[n[0]]; });
        res[0].forEach(function (p, i) {
          if (!p || shown[p.handle]) return; var v = p.variants.filter(function (x) { return x.available; })[0]; if (!v) return;
          shown[p.handle] = 1; html += card(p, v, need[i][1]);
        });
        if (left > 0 && res[1].length) {
          var cand = [];
          res[1].forEach(function (p) {
            if (inCart[p.handle] || shown[p.handle]) return;
            var v = p.variants.filter(function (x) { return x.available; })[0]; if (!v) return;
            var pr = cents(v);
            if (pr < 1500 || pr > left + 9000) return;
            cand.push([pr >= left ? pr - left : 100000 + (left - pr), p, v, pr]);
          });
          cand.sort(function (a, b) { return a[0] - b[0]; });
          /* cel mult un produs din acelasi tip (nu 3 nuante de Gummy la rand) */
          var seenT = {}; cand = cand.filter(function (c) { var t = (c[1].product_type || c[1].title.split(' ').slice(0, 3).join(' ')).toLowerCase(); if (seenT[t]) return false; seenT[t] = 1; return true; });
          cand.slice(0, 3).forEach(function (c) { fill += card(c[1], c[2], forMin ? (c[3] >= left ? 'Cu el treci de comanda minima' : 'Te apropie de comanda minima') : (c[3] >= left ? 'Cu el ai transport gratuit' : 'Te apropie de transport gratuit')); });
        }
        if (!html && !fill && !tog) { unwait(box); box.hidden = true; box.innerHTML = ''; try { sessionStorage.removeItem('cfb:' + sigOf(cart)); } catch (e) {} return; }
        var fillHtml = fill ? '<p class="cf-boost__h">Mai ai ' + money(left) + (forMin ? ' pana la comanda minima' : ' pana la transport gratuit') + '</p>' + fill : '';
        /* sub minim: completarea pana la minim sta prima */
        var out = (forMin ? fillHtml : '') + (tog ? '<p class="cf-boost__h">Clientele iau des si</p>' + tog : '') +
          (html ? '<p class="cf-boost__h">Completeaza manichiura</p>' + html : '') +
          (forMin ? '' : fillHtml);
        /* acelasi continut ca cel pus din memorie: nu-l rescriem (fara reincarcarea pozelor) */
        if (!(box.hasAttribute('data-cf-cached') && box.innerHTML === out)) box.innerHTML = out;
        box.removeAttribute('data-cf-cached');
        unwait(box);
        box.hidden = false;
        remember(box, cart);
      });
      });
      });
    });
  }
  function all() { document.querySelectorAll('[data-cf-boost]').forEach(render); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cf-boost-add]'); if (!b || b.disabled) return;
    b.disabled = true; b.textContent = '…';
    var drawer = document.querySelector('cart-drawer'), body = { id: +b.getAttribute('data-cf-boost-add'), quantity: 1 };
    try { if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(function (s) { return s.section; }); body.sections_url = location.pathname; } } catch (_) { drawer = null; }
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status >= 400) throw new Error(res.description || 'eroare');
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: res, source: 'coria-boost' } }));
        if (location.pathname.indexOf('/cart') === 0) { location.reload(); return; }
        if (drawer && drawer.renderContents && res.sections) { try { drawer.renderContents(res); } catch (_) {} }
        setTimeout(all, 300);
      })
      .catch(function () { b.disabled = false; b.textContent = '+'; });
  });
  ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(all, 400); }); });
  function start() {
    document.querySelectorAll('[data-cf-boost]').forEach(function (b) { b.setAttribute('data-cf-done', ''); render(b); });
    var d = document.querySelector('cart-drawer');
    if (d) new MutationObserver(function () {
      var b = d.querySelector('[data-cf-boost]:not([data-cf-done])'); if (b) { b.setAttribute('data-cf-done', ''); render(b); }
    }).observe(d, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
